var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowlSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2367 29.8854C48.6297 27.1786 47.3713 21.564 44.8951 10.1348C44.8482 9.84584 44.7768 9.56664 44.6841 9.30305C43.2574 4.71597 36.6674 0 24.9998 0C13.0747 0 6.45393 4.92648 5.22871 9.60678C5.20549 9.69018 5.18352 9.77403 5.16454 9.85921C5.1628 9.86769 5.1603 9.87572 5.15855 9.88374C2.64669 21.4841 1.37453 27.1586 0.763296 29.8854C0.0431959 33.0983 0 33.2906 0 34.3275C0 38.9637 2.67965 42.4139 8.19251 44.8753C12.7049 46.8904 18.6739 48 25 48C31.3261 48 37.2951 46.8904 41.8075 44.8753C47.3201 42.4139 50 38.9637 50 34.3275C50 33.2906 49.9568 33.0983 49.2367 29.8854ZM39.7231 10.7021C37.2237 12.752 32.4844 15.4922 25 15.4922C17.5149 15.4922 12.7763 12.7515 10.2772 10.7021C12.5129 8.91102 17.0559 6.68996 25 6.68996C32.9441 6.68996 37.4874 8.91102 39.7231 10.7021Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowlSolid);
export default __webpack_public_path__ + "static/media/bowl-solid.0d5aea21b1daca183c05f9221b6d636b.svg";
export { ForwardRef as ReactComponent };